import { useCallback, useState } from 'react';
import { useIsMounted } from './isMounted';

export const useMountedState = (defaultValue) => {
    const isMounted = useIsMounted();
    const [state, setState] = useState(defaultValue);
    const defensiveSetState = useCallback((newValue) => {
        if (isMounted()) {
            setState(newValue);
        }
    }, []);

    return [state, defensiveSetState, isMounted];
};
